import type { StaticEntityType } from "@config";
import { TickerView } from "./ticker.view";

interface IProps {
  entity: StaticEntityType;
}

export const TickerLibrary = (props: IProps) => {
  return <TickerView entity={props.entity} />;
};
